<template>
  <div>
    <div
      :class="[gameType === 'MW' ? 'modal modal-game_memory_wizard' : gameType === 'ODD' ? 'modal modal-game_odd_object alternative_flow_odd_modal'
      : 'modal modal-game_spot_difference']"
      :id="[gameType === 'MW' ? 'modal-game_memory_wizard' : gameType === 'ODD' ? 'modal-game_odd_object': 'modal-game_spot_difference']">
      <div class="modal__content lost_game_modal">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">
          <div class="row gamepage_header">
            <img v-if="gameType === 'MW'" class="gamepage_logo " src="static/images/logo-memory-wizard.png"/>
            <img v-if="gameType === 'ODD'" class="gamepage_logo " src="static/images/logo-odd-object.png"/>
            <img v-if="gameType === 'SD'" class="gamepage_logo " src="static/images/logo-spot-difference.png"/>
            <h1 v-if="gameType === 'MW'">{{ getTranslations.home_game_memory_wizard }}</h1>
            <h1 v-if="gameType === 'ODD'">{{ getTranslations.home_game_odd_game }}</h1>
            <h1 v-if="gameType === 'SD'">{{ getTranslations.home_game_sd_game }}</h1>
            <p>{{ getTranslations.home_modals_offtime_oh_no }}</p>
            <p>{{ getTranslations.home_modals_offtime_time_is_up }}</p>
          </div>
        </div>
        <div class="modal__body">
          <img class="modal_result" src="static/images/postgame-time-up.png"/>
          <p class="cta_support">{{ getTranslations.visitor_game_but_do_not_worry }}</p>
          <div  class="alternative_flow_jackpot_prize">
            <img :src="getTranslations.project_config_modal_img">
          </div>
          <a class="ti_btn--green modal_cta" style="cursor:pointer"
             @click.prevent="goToRegisterPage()">{{ getTranslations.visitor_game_save_points }}</a>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapState, mapMutations } from 'vuex';
import modals from '../../../common/modals';

export default {
  name: 'wrong-answer-visitor',
  created() {
    console.log('in Time is Up created hook:');
  },
  methods: {
    ...mapMutations('game', [
      'resetGameState',
      'resetPrizeData',
    ]),
    ...mapMutations('common', [
      'resetUnauthorizedMsisdn',
      'resetCode',
      'validTransitionForFreeGameMethod',
      'storeModalForHomePage',
    ]),
    goToRegisterPage() {
      modals.resetAllUserInfo(this);
      this.$router.push('/alternativetwostepregister1');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'gameType',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeGameProcess/TimeIsUpVisitor.vue